export const Props = () => ({
  //Объект, откуда можно получить данные подкаста
  post: {
    type: Object,
    required: true,
  },
});